// extracted by mini-css-extract-plugin
export var container = "_fg-0";
export var content = "_fg-3";
export var customerTitle = "_fg-4";
export var empty = "_fg-5";
export var gray = "_fg-6";
export var header = "_fg-7";
export var info = "_fg-8";
export var loading = "_fg-2";
export var loadingCard = "_fg-9";
export var oneLine = "_fg-a";
export var personName = "_fg-e";
export var pillContainer = "_fg-b";
export var selected = "_fg-1";
export var text = "_fg-c";
export var twoLines = "_fg-d";
export var unread = "_fg-f";
export var unreadIndicator = "_fg-g";